<template>
  <div v-if="isIntegrationEnabled('yotpo')" :class="{ relative: $storyblok.isEditing.value }">
    <KetchWrapper name="Testimonials" class="bg-gray-lighter">
      <YotpoTestimonials />
    </KetchWrapper>

    <!-- Shade for storyblok editor to prevent clicks -->
    <div v-if="$storyblok.isEditing.value" class="absolute inset-0 z-50"></div>
  </div>
</template>

<script setup lang="ts">
const { $storyblok } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
</script>
